export default {
  nav: {
    coreLogic: 'Logic Cốt Lõi',
    profitMechanism: 'Cơ Chế Lợi Nhuận',
    profitFlywheel: 'Bánh Đà Lợi Nhuận',
    sysArch: 'Kiến Trúc Hệ Thống',
    tradingExample: 'Trường Hợp Giao Dịch',
    cta: 'Bắt Đầu',
    language: 'Ngôn Ngữ',
  },
  hero: {
    badge: 'Poly Ai Claw Intelligence Engine',
    title1: 'Từ Dự Đoán Đến',
    title2: 'Kinh Doanh Chênh Lệch Xác Suất',
    desc: 'Polywin nâng cấp thị trường dự đoán thành công cụ kinh doanh chênh lệch có hệ thống nhờ Poly Ai Claw Intelligence Engine',
    ctaPrimary: 'Khởi Động Poly Ai Claw Engine',
    ctaSecondary: 'Xem Demo',
    statsEvents: 'Sự Kiện Theo Dõi',
    statsSuccessRate: 'Tỷ Lệ Thành Công',
    statsExecTime: 'Thời Gian Thực Thi',
    cardTitle: 'Phân Tích Độ Lệch Xác Suất',
    cardBadge: 'Vùng Lợi Thế EV',
    cardMarketProb: 'Xác Suất Thị Trường',
    cardAiProb: 'Xác Suất AI',
    cardMarketImplied: 'Xác Suất Tiềm Ẩn Thị Trường',
    cardAiTrue: 'Xác Suất Thực AI',
    cardProbDiff: 'Lợi Thế Xác Suất',
  },
  coreLogic: {
    badge: 'Hệ Thống Quyết Định PolyAi-Claw',
    title1: 'Từ Tổng Hợp Dữ Liệu Đến Lợi Nhuận Kép —',
    title2: 'Vòng Lặp Tự Động Hoàn Toàn',
    desc: 'Dữ liệu đa nguồn → AI → Lệch xác suất → Tự động thực thi → Lợi nhuận kép',
    step0_title: 'Lớp Dữ Liệu',
    step0_sub: 'Tổng Hợp Đa Nguồn',
    step0_i0: 'Sự Kiện Chính Trị',
    step0_i1: 'Kinh Tế Vĩ Mô',
    step0_i2: 'Tâm Lý Xã Hội',
    step0_i3: 'Dữ Liệu Sổ Lệnh',
    step1_title: 'Mô Hình AI',
    step1_sub: 'Cập Nhật Xác Suất Bayes',
    step1_i0: 'Nhập Dữ Liệu Thời Gian Thực',
    step1_i1: 'AI Modeling Engine',
    step1_i2: 'Tính Toán Xác Suất',
    step1_i3: 'Tối Ưu Hóa Mô Hình',
    step2_title: 'Phát Hiện Lệch',
    step2_sub: 'Nhận Dạng Lệch Xác Suất',
    step2_i0: 'Xác Suất Tiềm Ẩn Thị Trường',
    step2_i1: 'Xác Suất Thực AI',
    step2_i2: 'Nhận Dạng Lợi Thế EV',
    step2_i3: 'Tín Hiệu Vào Lệnh',
    step3_title: 'Thực Thi Onchain',
    step3_sub: 'Giao Dịch Tự Động Polygon',
    step3_i0: 'Kiểm Soát Rủi Ro',
    step3_i1: 'Phân Bổ Vốn',
    step3_i2: 'Thanh Toán USDC',
    step3_i3: 'Hợp Đồng Thông Minh',
    step4_title: 'Lợi Nhuận Kép',
    step4_sub: 'Tái Đầu Tư Tự Động',
    step4_i0: 'Thanh Toán Sự Kiện',
    step4_i1: 'Thanh Lý Lợi Nhuận',
    step4_i2: 'Tính Toán Lãi Kép',
    step4_i3: 'Vòng Lặp Tái Đầu Tư',
    keyTitle: 'Mục Tiêu Cốt Lõi',
    keyDesc: 'Mục tiêu của PolyAi-Claw là liên tục tìm kiếm định giá sai xác suất (Mispricing) trên thị trường và thực hiện kinh doanh chênh lệch có hệ thống.',
    keyHighlight: 'liên tục tìm kiếm định giá sai xác suất và thực hiện kinh doanh chênh lệch có hệ thống',
  },
  profitMechanism: {
    badge: 'Cơ Chế Lợi Nhuận Cốt Lõi',
    title1: '3 Cơ Chế',
    title2: 'Lợi Nhuận của PolyAi-Claw',
    desc: 'Hệ thống kinh doanh chênh lệch xác suất ổn định qua nhận diện lợi thế EV, thực thi mili giây và quản lý vốn 3 tầng',
    m1_title: 'Nhận Diện Lợi Thế EV',
    m1_sub: 'Probability Edge Detection',
    m1_desc: 'Logic cốt lõi: Giá thị trường ≠ Xác suất thực. Khi AI phát hiện lệch, tự động vào vùng lợi thế EV và kích hoạt lệnh.',
    m1_marketImplied: 'Xác Suất Tiềm Ẩn Thị Trường',
    m1_aiTrue: 'Xác Suất Thực AI',
    m1_probDiff: 'Lợi Thế Xác Suất',
    m1_note: 'Nguyên lý giống kinh doanh chênh lệch quyền chọn quỹ quant',
    m2_title: 'Thực Thi Tự Động Mili Giây',
    m2_sub: 'Millisecond Execution',
    m2_desc: 'Khung thực thi tự động hoàn toàn đảm bảo cơ hội kinh doanh chênh lệch không bị mất.',
    m2_i0_title: 'Tốc Độ Thực Thi Mili Giây',
    m2_i0_sub: 'TB <200ms',
    m2_i1_title: 'Hoàn Toàn Minh Bạch Onchain',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: 'Không Can Thiệp Con Người',
    m2_i2_sub: 'Hợp Đồng Thông Minh Tự Thanh Toán',
    m2_network_label: 'Mạng Thực Thi',
    m2_network_val: 'Polygon + USDC',
    m3_title: 'Quản Lý Vốn 3 Tầng',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: 'Tránh đòn bẩy cao và rủi ro một điểm trong đầu cơ truyền thống.',
    m3_i0_title: 'Quỹ Lợi Nhuận Ổn Định',
    m3_i0_desc: 'Kinh doanh chênh lệch xác suất độ chắc chắn cao, rủi ro thấp nhất',
    m3_i1_title: 'Quỹ Kinh Doanh Biến Động',
    m3_i1_desc: 'Nắm bắt biến động thị trường, độ đàn hồi lợi nhuận cao',
    m3_i2_title: 'Quỹ Bảo Vệ Phòng Ngừa',
    m3_i2_desc: 'Phòng ngừa sự kiện ít tương quan, giảm rủi ro hệ thống',
    m3_risk: 'Rủi Ro Mỗi Sự Kiện < 5%',
    formula_title: 'Công Thức Kinh Doanh Chênh Lệch Xác Suất',
    formula_marketPrice: 'Giá Thị Trường',
    formula_aiTrue: 'Xác Suất Thực AI',
    formula_trigger: 'Kích Hoạt Lệnh',
    formula_arbitrage: 'Kinh Doanh CL',
    formula_hiddenPct: 'Tiềm Ẩn 60%',
    formula_evEdge: 'Lợi Thế EV +12%',
    formula_autoExec: 'Tự Động Thực Thi',
  },
  fundManagement: {
    riskTitle: 'Nguyên Tắc Kiểm Soát Rủi Ro Cốt Lõi',
    riskDesc: 'Hệ thống đặt giới hạn rủi ro tối đa mỗi sự kiện < 5%.',
    riskHighlight: 'giới hạn rủi ro tối đa mỗi sự kiện < 5%',
    stat_maxSingle: 'Đầu Tư Tối Đa Mỗi Lần',
    stat_maxSingleVal: '5%',
    stat_diversify: 'Đa Dạng Hóa Vốn',
    stat_diversifyVal: '20+ Sự Kiện',
    stat_stopLoss: 'Cơ Chế Cắt Lỗ',
    stat_stopLossVal: 'Tự Động Kích Hoạt',
    vizTitle: 'Hình Ảnh Hóa Dữ Liệu Rủi Ro',
    viz_exposure: 'Kiểm Soát Rủi Ro',
    viz_diversify: 'Đa Dạng Vốn',
    viz_correlation: 'Tương Quan Sự Kiện',
    viz_stability: 'Ổn Định Chiến Lược',
  },
  techAdvantage: {
    badge: 'Lợi Thế Cốt Lõi',
    title1: 'Tại Sao PolyAi-Claw',
    title2: 'Vượt Trội Hơn Thị Trường Dự Đoán Truyền Thống?',
    dim_decision: 'Cơ Sở Quyết Định',
    dim_monitor: 'Tần Suất Theo Dõi',
    dim_execute: 'Phương Thức Thực Thi',
    dim_model: 'Mô Hình Nhận Thức',
    dim_risk: 'Kiểm Soát Rủi Ro',
    human_decision: 'Dựa Cảm Xúc',
    human_monitor: 'Tần Suất Thấp',
    human_execute: 'Lệnh Thủ Công',
    human_model: 'Chủ Quan',
    human_risk: 'Dựa Kinh Nghiệm',
    ai_decision: 'Dựa Dữ Liệu',
    ai_monitor: 'Tần Suất Cao',
    ai_execute: 'Tự Động Thực Thi',
    ai_model: 'Mô Hình Xác Suất',
    ai_risk: 'Quản Lý Thuật Toán',
    humanPredict: 'Dự Đoán Của Con Người',
    adv1_title: 'Dựa Dữ Liệu vs Cảm Xúc',
    adv1_desc: 'PolyAi-Claw mô hình hóa dựa trên dữ liệu đa nguồn gồm sự kiện chính trị, kinh tế vĩ mô, tâm lý xã hội và dữ liệu sổ lệnh.',
    adv1_label: 'Số Nguồn Dữ Liệu',
    adv2_title: 'Tần Suất Cao vs Thấp',
    adv2_desc: 'Hệ thống theo dõi 24/7 không ngừng, nhận diện cơ hội lệch xác suất theo thời gian thực.',
    adv2_label: 'Tần Suất Theo Dõi',
    adv3_title: 'Tự Động vs Thủ Công',
    adv3_desc: 'Thực thi mili giây qua hợp đồng thông minh trên Polygon, không can thiệp con người.',
    adv3_label: 'Tốc Độ Thực Thi',
    adv4_title: 'Thuật Toán vs Kinh Nghiệm',
    adv4_desc: 'Hệ thống quản lý vốn 3 tầng kiểm soát chặt rủi ro mỗi sự kiện dưới 5%.',
    adv4_label: 'Kiểm Soát Rủi Ro',
    conclusion_title: 'Từ Thị Trường Dự Đoán Đến Poly Ai Claw Intelligence Engine',
    conclusion_desc1: 'Điều này nâng cấp PolyWin từ một Prediction Market đơn giản thành',
    conclusion_brand: 'Poly Ai Claw Intelligence Engine',
    conclusion_desc2: 'Hệ Thống Dự Đoán Định Lượng Poly Ai Claw',
  },
  productNarrative: {
    badge: 'Định Vị Sản Phẩm',
    title: 'Bản Chất Thực Sự Của PolyWin',
    desc: 'PolyWin không chỉ là thị trường dự đoán mà là hệ thống tích hợp AI, thị trường dự đoán, OpenClaw và giao dịch định lượng.',
    item0_title: 'Hệ Thống Kinh Doanh Chênh Lệch Xác Suất',
    item0_sub: 'Liên tục nắm bắt định giá sai thị trường',
    item1_title: 'Mô Hình Thực Thi Kỷ Luật',
    item1_sub: 'Tự động hóa, không can thiệp cảm xúc',
    item2_title: 'AI Risk Management Engine',
    item2_sub: 'Kiểm soát rủi ro thông minh',
    visual_title: '3 Biểu Đạt Trực Quan',
    vis0_title: '① Biểu Đồ Lệch Đường Cong Xác Suất',
    vis0_desc: 'Hiển thị đường cong xác suất AI vs đường cong định giá thị trường',
    vis0_ai: 'Xác Suất AI',
    vis0_market: 'Giá Thị Trường',
    vis0_diff: 'Độ Lệch',
    vis1_title: '② Biểu Đồ Radar Kiểm Soát Rủi Ro',
    vis1_desc: 'Hiển thị rủi ro, đa dạng vốn, tương quan sự kiện, ổn định chiến lược',
    vis1_exposure: 'Rủi Ro',
    vis1_diversify: 'Đa Dạng Vốn',
    vis1_safe: 'Vùng An Toàn',
    vis1_safeVal: 'Đã Vào',
    vis2_title: '③ Sơ Đồ Giao Dịch Tự Động AI',
    vis2_desc: 'Làm nổi bật vòng lặp: Dữ liệu → AI → Thực thi → Thanh lý → Lãi kép',
    vis2_exec: 'Tốc Độ Thực Thi',
    vis2_execVal: 'Mili Giây',
    vis2_auto: 'Tỷ Lệ Tự Động Hóa',
    vis2_compound: 'Vòng Lặp Lãi Kép',
    vis2_compoundVal: 'Liên Tục',
    core_title: 'Đề Xuất Giá Trị Cốt Lõi',
    core_desc: 'Thông qua định giá xác suất tự động và cơ chế lãi kép, PolyAi-Claw liên tục nắm bắt độ lệch định giá trong khi đảm bảo kiểm soát rủi ro.',
    core_highlight: 'định giá xác suất tự động và cơ chế lãi kép',
    core_item0: 'Định Giá Xác Suất Tự Động',
    core_item1: 'Cơ Chế Lãi Kép',
    core_item2: 'Đảm Bảo Kiểm Soát Rủi Ro',
    core_item3: 'Nắm Bắt Lệch Liên Tục',
  },
  profitFlywheel: {
    badge: 'Bánh Đà Tăng Trưởng Tài Chính Điều Khiển AI',
    title1: 'PolyWin AI',
    title2: 'Mô Hình Bánh Đà Lợi Nhuận',
    desc: 'Tăng trưởng của PolyWin không phụ thuộc vào lợi nhuận giao dịch đơn lẻ mà dựa vào hệ thống lãi kép liên tục điều khiển AI',
    descHighlight: 'hệ thống lãi kép liên tục điều khiển AI',
    aiCore: 'AI Probability Engine',
    step1_title: 'Nhập Dữ Liệu Toàn Cầu',
    step1_sub: 'Global Data',
    step1_desc: 'AI liên tục theo dõi tin tức, thay đổi chính trị, kinh tế vĩ mô, tâm lý xã hội',
    step1_tech: '50+ Nguồn Dữ Liệu',
    step1_techDetail: 'Hợp nhất thời gian thực đa nguồn',
    step2_title: 'Mô Hình Xác Suất AI',
    step2_sub: 'Probability Modeling',
    step2_desc: 'Sử dụng mô hình Bayes, mô hình hiệu chỉnh tâm lý để tính xác suất thực',
    step2_tech: 'Mô Hình Bayes',
    step2_techDetail: 'Cập nhật xác suất động thời gian thực',
    step3_title: 'Phát Hiện Lệch Xác Suất',
    step3_sub: 'Probability Edge',
    step3_desc: 'Khi xác suất thực AI > xác suất tiềm ẩn thị trường, nhận dạng là EV Positive Opportunity',
    step3_tech: 'Lệch EV >5%',
    step3_techDetail: 'Tự động phát hiện EV dương',
    step4_title: 'Thực Thi Giao Dịch Tự Động',
    step4_sub: 'Algorithmic Execution',
    step4_desc: 'Hệ thống tự động hoàn thành xây dựng vị thế, phòng ngừa, thực thi lệnh',
    step4_tech: 'Hợp Đồng Thông Minh',
    step4_techDetail: '<200ms thực thi mili giây',
    step5_title: 'Lợi Nhuận Thị Trường Dự Đoán',
    step5_sub: 'Market Profit',
    step5_desc: 'Khi kết quả sự kiện xác nhận, hệ thống thu được lợi nhuận kinh doanh chênh lệch',
    step5_tech: 'Polygon PoS',
    step5_techDetail: 'Thanh lý tự động onchain',
    step6_title: 'Thu Hồi Vốn',
    step6_sub: 'Capital Recycling',
    step6_desc: 'Hệ thống tự động thu hồi vốn lợi nhuận vào quỹ',
    step6_tech: 'Thanh Toán USDC',
    step6_techDetail: 'Stablecoin không mất phí tỷ giá',
    step7_title: 'Tăng Trưởng Lãi Kép',
    step7_sub: 'Compounding Capital',
    step7_desc: 'Khi quy mô quỹ tăng, AI có thể tham gia thị trường lớn hơn',
    step7_tech: 'Lãi Kép Tự Động',
    step7_techDetail: 'Vòng lặp tái đầu tư tự động',
    step8_title: 'Quy Mô Vốn Lớn Hơn',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: 'Quy mô vốn lớn hơn đồng nghĩa với khả năng giao dịch cao hơn và lợi nhuận ổn định hơn',
    step8_tech: 'Mở Rộng Thanh Khoản',
    step8_techDetail: 'Quy mô càng lớn lợi thế càng tăng',
    sum0_label: 'Lớp Dữ Liệu',
    sum0_tech: '50+ Luồng Đa Nguồn',
    sum0_detail: 'Mô hình Bayes thời gian thực',
    sum1_label: 'Lớp Thực Thi',
    sum1_tech: 'Tự Động Hóa Hợp Đồng Thông Minh',
    sum1_detail: 'Thanh toán onchain Polygon PoS',
    sum2_label: 'Lớp Thanh Toán',
    sum2_tech: 'USDC Stablecoin',
    sum2_detail: 'Thanh toán không mất phí tỷ giá',
    sum3_label: 'Lớp Lãi Kép',
    sum3_tech: 'Tái Đầu Tư Tự Động',
    sum3_detail: 'Vòng lặp mở rộng quy mô dương',
    key0_title: 'Vòng Lặp Tự Tăng Cường',
    key0_desc: 'Mỗi lợi nhuận đều tăng cường năng lực hệ thống, tạo vòng phản hồi tích cực',
    key1_title: 'Tăng Trưởng Điều Khiển AI',
    key1_desc: 'Tăng trưởng không phụ thuộc giới thiệu mà dựa vào khả năng kinh doanh chênh lệch xác suất của AI',
    key2_title: 'Hệ Thống Lãi Kép Liên Tục',
    key2_desc: 'Thu hồi và tái đầu tư lợi nhuận tự động giúp quy mô quỹ mở rộng liên tục',
    formula_title: 'Công Thức Tăng Trưởng Bánh Đà',
    f0_label: 'Dữ Liệu AI',
    f1_label: 'Kinh Doanh CL',
    f2_label: 'Lợi Nhuận',
    f3_label: 'Lãi Kép',
    f4_label: 'Vốn Lớn Hơn',
    f5_label: 'CL Nhiều Hơn',
    connected: 'Đã Kết Nối · Trực Tiếp',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: 'Kiến Trúc Hệ Thống',
    desc: 'Hệ thống quyết định AI hoàn chỉnh từ thu thập dữ liệu đến thanh toán tự động',
    coreBadge: 'Não AI Cốt Lõi',
    feat0_title: 'Cấu Trúc Hệ Thống AI Hoàn Chỉnh',
    feat0_desc: 'Không phải chiến lược đơn giản mà là hệ thống quyết định AI hoàn chỉnh',
    feat1_title: 'Kiểm Soát Rủi Ro Cấp Quỹ Quant',
    feat1_desc: 'Mô hình kiểm soát rủi ro quỹ quant chuyên nghiệp',
    feat2_title: 'Kiến Trúc Có Thể Mở Rộng',
    feat2_desc: 'Có thể mở rộng sang đa thị trường, đa chuỗi, đa chiến lược',
    dataflow_title: 'Luồng Dữ Liệu',
  },
  tradingExample: {
    badge: 'Nghiên Cứu Tình Huống Thực Tế',
    title1: 'PolyAi-Claw BTC',
    title2: 'Chiến Lược Kinh Doanh Chênh Lệch 5 Phút',
    desc: 'Hệ thống chỉ làm 3 việc: Phát hiện biến động bất thường → Phán đoán xác suất 60 giây cuối → Giao dịch trong vùng an toàn',
    s1_title: 'BTC Market Data',
    s1_sub: 'Theo Dõi Thị Trường Thời Gian Thực',
    s1_notice: 'Dữ liệu mẫu điều kiện kích hoạt chiến lược',
    s1_price: 'Giá Hiện Tại',
    s1_eg: 'Ví Dụ',
    s1_priceVol: 'Biến Động Giá',
    s1_vol: 'Khối Lượng',
    s1_depth: 'Độ Sâu Sổ Lệnh',
    s1_trigger: 'Kích Hoạt: Biến Động ≥ 100 USD',
    s1_met: 'Đã Đáp Ứng',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'Tính Toán Xác Suất AI',
    s2_marketImplied: 'Xác Suất Tiềm Ẩn Thị Trường',
    s2_aiTrue: 'Xác Suất Thực AI',
    s2_yes: 'YES',
    s2_probDiff: 'Lợi Thế Xác Suất',
    s2_safe: 'Vào Vùng Giao Dịch An Toàn',
    s3_title: 'Auto Trade + Profit',
    s3_sub: 'Thực Thi Tự Động & Lợi Nhuận',
    s3_exec: 'Thực Thi Giao Dịch',
    s3_buyYes: 'Mua YES',
    s3_buyPrice: 'Giá Vào',
    s3_settlement: 'Thanh Toán Thị Trường Dự Đoán',
    s3_correct: 'Dự Đoán Đúng',
    s3_profit: 'Lợi Nhuận Mỗi Giao Dịch',
    s3_avg: 'Tỷ Lệ Lợi Nhuận Trung Bình',
    s3_recycle: 'Lợi Nhuận Được Thu Hồi Vào Quỹ',
    chart_title: 'Biểu Đồ Lệch AI vs Thị Trường',
    chart_sub: 'Theo dõi thời gian thực lệch xác suất Poly Ai Claw vs thị trường để nhận diện cửa sổ kinh doanh chênh lệch',
    chart_live: 'Live Analysis',
    chart_curDev: 'Lệch Hiện Tại',
    chart_signal: 'Tín Hiệu Kinh Doanh CL',
    chart_signalVal: 'Đã Kích Hoạt',
    chart_winRate: 'Dự Báo Tỷ Lệ Thắng',
    chart_bottom_implied: 'Xác Suất Tiềm Ẩn TT',
    chart_bottom_dev: 'Vùng Lệch Xác Suất',
    chart_bottom_dev_sub: 'Cơ hội kinh doanh chênh lệch đã kích hoạt',
    chart_bottom_ai: 'Xác Suất Thực AI',
    chart_bottom_ai_sub: 'Đầu Ra Mô Hình Poly Ai Claw',
    chart_bottom_implied_sub: 'Dựa trên giá thị trường',
    chart_marketProb: 'Xác Suất Tiềm Ẩn TT',
    chart_aiProb: 'Xác Suất Thực AI',
    chart_deviationArea: 'Vùng Lệch Kinh Doanh CL',
    maxDeviation: 'Lệch Tối Đa',
    deviation: 'Lệch',
    flow_title: 'Luồng Chiến Lược Hoàn Chỉnh',
    flow0_title: 'Theo Dõi Dữ Liệu BTC',
    flow0_desc: 'Giá/Khối lượng thời gian thực',
    flow1_title: 'Phát Hiện Biến Động',
    flow1_desc: '≥ 100 USD',
    flow2_title: 'Bộ Lọc Thời Gian',
    flow2_desc: '60 giây cuối',
    flow3_title: 'Đánh Giá Tỷ Lệ Thắng',
    flow3_desc: '≥ 60-70%',
    flow4_title: 'Tự Động Thực Thi',
    flow4_desc: 'Mua YES/NO',
    flow5_title: 'Thanh Toán Thị Trường',
    flow5_desc: '1 USDC',
    flow6_title: 'Lãi Kép',
    flow6_desc: '3%-10%',
    risk0_title: 'Cấu Trúc Kiểm Soát Rủi Ro',
    risk0_i0: 'Giới hạn vốn mỗi sự kiện < 5%',
    risk0_i1: 'Đa dạng hóa đa sự kiện',
    risk0_i2: 'Cắt lỗ động AI',
    risk1_title: 'Chiến Lược Thời Gian',
    risk1_i0: 'Thực thi trong 60 giây cuối',
    risk1_i1: 'Tránh giao dịch cảm xúc',
    risk1_i2: 'Thông tin đầy đủ hơn',
    risk2_title: 'Hiệu Suất Lịch Sử',
    risk2_i0: 'Tỷ lệ thắng lịch sử 80%-90%',
    risk2_i1: 'Lợi nhuận trung bình 3%-10%',
    risk2_i2: 'Mô hình kinh doanh chênh lệch ổn định',
  },
  crossPlatform: {
    badge: 'Kinh Doanh Chênh Lệch Đa Nền Tảng',
    title1: 'PolyAi CLaw',
    title2: 'Logic Kinh Doanh Chênh Lệch Thị Trường Dự Đoán Đa Nền Tảng',
    desc: 'Kết nối Polymarket (Web3) và Kalshi (Tiền Fiat), nắm bắt độ lệch giá, thực hiện khớp thông minh + thực thi siêu nhanh',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: 'Tiền Fiat',
    claw: 'CLaw',
    matched: '✓ Đã Khớp',
    matching: 'Đang Khớp...',
    sec1_badge: '01',
    sec1_accuracy: '99%+ Độ Chính Xác',
    sec1_title: 'Khớp Thị Trường Thông Minh',
    sec1_desc: 'Các sự kiện trên hai nền tảng được AI ngữ nghĩa tự động liên kết',
    sec2_badge: '02',
    sec2_ms: 'Thực Thi Mili Giây',
    sec2_title: 'Tích Hợp Thống Nhất & Giao Dịch Siêu Nhanh',
    sec2_desc: 'API/SDK thống nhất kết nối đa nền tảng, đặt lệnh đồng bộ mili giây',
    connected: 'Đã Kết Nối · Trực Tiếp',
    latency: 'Độ Trễ Lệnh',
    dailyEvents: 'Sự Kiện Khớp Hằng Ngày',
    successRate: 'Tỷ Lệ Thực Thi Thành Công',
    platforms: 'Nền Tảng Đồng Bộ',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: 'Hình Ảnh Hóa Dữ Liệu Kinh Doanh CL',
    sec3_desc: 'Độ lệch giá thời gian thực, lợi nhuận kinh doanh chênh lệch và xu hướng tăng trưởng',
    priceDeviation: 'Phân Phối Độ Lệch Giá',
    volumeTitle: 'Khối Lượng Hàng Tháng (K USDC)',
    h1Volume: 'Khối Lượng Tích Lũy H1 (USDC)',
    arbIndicators: 'Chỉ Số Lợi Thế Kinh Doanh CL',
    arbSuccess: 'Tỷ Lệ Thành Công Spread',
    semanticAccuracy: 'Độ Chính Xác Khớp Ngữ Nghĩa',
    liquidity: 'Thanh Khoản Đa Nền Tảng',
    hedgeCoverage: 'Tỷ Lệ Bao Phủ Phòng Ngừa',
  },
  mathAlgo: {
    badge: 'Thuật Toán Toán Học Chính Xác Nâng Cao',
    title1: 'Kinh Doanh Chênh Lệch Polymarket',
    title2: 'Không Phải Bài Toán Đơn Giản',
    quote: 'Trong khi bạn vẫn đang tính phép cộng thủ công, hệ thống quant đã làm một việc hoàn toàn khác.',
    quoteHighlight1: 'tính thủ công',
    quoteHighlight2: 'việc hoàn toàn khác',
    ch0_title: 'Kinh Doanh CL Là Gì? Tại Sao Polymarket Có Nhiều Thế?',
    ch0_tag: 'Kém Hiệu Quả Thị Trường',
    ch1_title: 'Kinh Doanh CL Đa Thị Trường: Phụ Thuộc Logic',
    ch1_tag: 'Toán Tổ Hợp',
    ch2_title: 'Bregman Projection: Tính Quy Mô Kinh Doanh CL Tối Ưu',
    ch2_tag: 'Tối Ưu Lồi',
    pipeline_title: 'Hệ Thống Kinh Doanh CL Polymarket — Kiến Trúc Đầy Đủ',
    layer0: 'Lớp 1: Thu Thập Dữ Liệu',
    layer1: 'Lớp 2: Phát Hiện Phụ Thuộc',
    layer2: 'Lớp 3: Công Cụ Tối Ưu 3 Cấp',
    layer3: 'Lớp 4: Thực Thi & Quản Lý Vị Thế',
    annualProfit: 'Tổng Lợi Nhuận Khai Thác Hàng Năm: $39,688,585',
    venn_title: 'Phụ Thuộc Logic: P(Thắng 5%) ⊆ P(Thắng)',
    contradiction: 'Mâu Thuẫn! P(tập con) > P(tập cha) → Tín hiệu kinh doanh CL kích hoạt',
    contradiction_sub: '0.55 > 0.48 → Mâu thuẫn logic → Cơ hội kinh doanh CL',
    combinations: 'Tổ Hợp Thị Trường',
    brutal: 'Không thể liệt kê toàn bộ',
    integerConstraints: 'Ràng Buộc Quy Hoạch Nguyên',
    replaces: 'Thay thế 16,384 lần liệt kê',
    bregman_title: 'KL Divergence vs Khoảng Cách Euclid',
    coreData: 'Dữ Liệu Cốt Lõi',
    pipeline4: 'Pipeline 4 Lớp Hệ Thống',
    annualReturn: 'Lợi Nhuận Hàng Năm ≈ $39.7M',
    whyNotEnough_title: 'Tại Sao "Tổng Giá = $1" Chưa Đủ?',
    singleMarket: 'Một Thị Trường — Có Vẻ Bình Thường',
    crossMarket: 'Đa Thị Trường — Bùng Nổ Hàm Mũ',
  },
  mathProfit: {
    ch3_title: 'Thuật Toán Frank-Wolfe: Tiếp Cận Đáp Án Từng Bước',
    ch3_tag: 'Thuật Toán Lặp',
    ch3_chapter: 'Chương 04',
    execTitle: 'Rủi Ro Thực Thi Không Nguyên Tử',
    profitStructure: 'Cấu Trúc Lợi Nhuận (Tháng 4/2024 – 4/2025)',
    totalProfit: 'Tổng: $39,688,585',
    top10: 'TOP 10 chiếm 20.5%',
    kellyFormula: 'Công Thức Kelly Cải Tiến',
    preTrade: '4 Điểm Kiểm Tra Trước Giao Dịch',
    gate0: 'Thanh khoản đủ?',
    gate1: 'Slippage chấp nhận được?',
    gate2: 'Vẫn có lãi sau slippage?',
    gate3: 'Lợi nhuận > $0.05 → Thực thi',
  },
  safuFund: {
    badge: 'Đảm Bảo An Toàn Tài Sản',
    title: 'Quỹ SAFU Polywin',
    titleHighlight: 'Quỹ SAFU',
    desc: 'Dự trữ khóa onchain, minh bạch và có thể xác minh thời gian thực — tài sản của bạn, chúng tôi bảo vệ',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: 'Đã Xác Minh Onchain',
    mainDesc: 'Nhóm Polywin đã khóa 10 triệu USDC làm quỹ dự trữ SAFU trên mạng chính Ethereum.',
    mainDescHighlight: '10 triệu USDC',
    contractLabel: 'Địa Chỉ Hợp Đồng',
    etherscanBtn: 'Xác Minh Trên Etherscan',
    stat0_label: 'Quy Mô Dự Trữ',
    stat0_sub: 'USDC',
    stat1_label: 'Tỷ Lệ Khóa Onchain',
    stat1_sub: 'On-Chain',
    stat2_label: 'Có Thể Xác Minh',
    stat2_sub: 'Real-time',
    stat3_label: 'Thanh Toán Lịch Sử',
    stat3_val: '$0',
    stat3_sub: 'Không Có Tổn Thất',
    f0_title: 'Khóa Onchain',
    f0_desc: '100% vốn được khóa trong hợp đồng thông minh Ethereum mainnet',
    f1_title: 'Hoàn Toàn Minh Bạch',
    f1_desc: 'Bất kỳ ai cũng có thể xem số dư và lịch sử giao dịch qua Etherscan',
    f2_title: 'Bồi Thường Nhanh',
    f2_desc: 'Quy trình bồi thường bắt đầu trong 72 giờ sau khi xác nhận sự cố',
    f3_title: 'Kiểm Toán Độc Lập',
    f3_desc: 'Cơ quan bảo mật bên thứ ba kiểm toán mã hợp đồng định kỳ',
  },
  cta: {
    badge: 'Bắt Đầu Ngay',
    title1: 'Bắt Đầu Sử Dụng',
    title2: 'Poly Ai Claw',
    title3: 'Intelligence Engine',
    desc: 'Không cần kinh nghiệm lập trình — cấu hình chiến lược AI trong 3 phút',
    btn: 'Khởi Động AI-Claw',
    trust0: 'Đối Tác Chính Thức Polygon',
    trust1: 'Được Chứng Nhận Kiểm Toán',
    trust2: '10.000+ Người Dùng Tích Cực',
    trust3: '$50M+ Khối Lượng Tích Lũy',
  },
  footer: {
    tagline: 'Poly Ai Claw Intelligence Engine',
    product: 'Sản Phẩm',
    resources: 'Tài Nguyên',
    social: 'Mạng Xã Hội',
    link0: 'Thuật Toán Poly AI-Claw',
    link1: 'Hệ Thống Kiểm Soát Rủi Ro',
    link2: 'Data API',
    link3: 'Tài Liệu Lập Trình Viên',
    res0: 'Hướng Dẫn',
    res1: 'Trường Hợp Chiến Lược',
    res2: 'Whitepaper',
    res3: 'Diễn Đàn Cộng Đồng',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: 'Chính Sách Bảo Mật',
    terms: 'Điều Khoản Dịch Vụ',
  },
};
